<template>


<div class="fixed-top" id="header">


  <b-navbar toggleable="lg" variant="" type=""  >
    <b-navbar-brand href="#">
      <router-link to="/Assamese">
      <table>
        <tbody>
          <tr>
              <td rowspan="5">  <b-img class="logo" src="../assets/apdcl_logo.png" fluid   alt="logo"></b-img></td>
          </tr>
            <tr>
              <td id="title-a" class="title-a text-blue ">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</td>
            </tr>
            <tr>
              <td id="tagline-a"  class="tagline-a text-blue"> অসম চৰকাৰৰ ৰাজহুৱা খণ্ডৰ এটি পৰিসীমিত কোম্পানী </td>
            </tr>
            <tr>
              <td id="title-e" class="title-e text-blue">ASSAM POWER DISTRIBUTION COMPANY LIMITED</td>
            </tr>
            <tr>
              <td id="tagline-e" class="tagline-e text-blue">A Govt. of Assam Public Limited Company</td>
            </tr>
        </tbody>
      </table>
    </router-link>
  </b-navbar-brand>

  <b-navbar-toggle target="nav-collapse" style="border:none; outline: none;">
      <template>
        <div style="border:solid 1px black;border-radius:3px;font-size: 2rem;text-align:right">
        <b-icon icon="list"  ></b-icon>
      </div>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="padding-left:2rem;z-index:10;">


      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
          <b-nav-item href="#"><router-link toggle-class="r-link" to="/Assamese">মূখ্যপৃষ্ঠা</router-link></b-nav-item>
          <b-nav-item href="#"><router-link toggle-class="r-link" to="/AS_ActsAndRules">আইন আৰু নীতি</router-link></b-nav-item>
          <!-- <b-nav-item href="#"><router-link toggle-class="r-link" to="/Tender">Tender</router-link></b-nav-item> -->

           <b-nav-item-dropdown toggle-class="r-link" text="নিবিদা" right>
            <b-dropdown-item href="AS_TenderCurrent"><span class="dropdownItem" >চলিত বিত্তীয় বৰ্ষ</span></b-dropdown-item>
            <b-dropdown-item href="AS_TenderPrevious"><span class="dropdownItem" >বিগত বিত্তীয় বৰ্ষ</span></b-dropdown-item>
            <b-dropdown-item href="AS_TenderArchive"><span class="dropdownItem" >আৰ্কাইভ</span></b-dropdown-item>

          </b-nav-item-dropdown>

          <!-- <b-nav-item-dropdown toggle-class="r-link" text="Newsroom" right>
            <b-dropdown-item href="#"><router-link to="/Newsletter">Newsletter</router-link></b-dropdown-item>
            <b-dropdown-item href="#"><router-link to="/BijuleeNewsBulletin">Bijulee News Bulletin</router-link></b-dropdown-item>
              <b-dropdown-item href="#"><router-link to="/PressRelease">Press Release</router-link></b-dropdown-item>
            <b-dropdown-item><a href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank">Talk Show about APDCL</a></b-dropdown-item>
            <b-dropdown-item href="#"><router-link to="/Testimonial">Testimonials</router-link></b-dropdown-item>
          </b-nav-item-dropdown> -->

          <b-nav-item-dropdown toggle-class="r-link" text="বাতৰি" right>
            <b-dropdown-item href="AS_Award"><span class="dropdownItem " >সন্মান আৰু স্বীকৃতি</span></b-dropdown-item>
            <b-dropdown-item href="AS_Newsletter"><span class="dropdownItem" >বাৰ্তালোচনী</span></b-dropdown-item>
            <b-dropdown-item href="AS_BijuleeNewsBulletin"><span class="dropdownItem" >বিজুলী প্ৰচাৰ-পত্ৰিকা</span></b-dropdown-item>
            <b-dropdown-item href="AS_PressRelease"><span class="dropdownItem" >প্ৰেছ বিজ্ঞপ্তি</span></b-dropdown-item>
            <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank"><span class="dropdownItem" >
              টক্-শ্ব’ত এপিদিচিএল</span></b-dropdown-item>
            <b-dropdown-item href="AS_Testimonial"><span class="dropdownItem" >দস্তাবেজ</span></b-dropdown-item>
            <b-dropdown-item href="AS_Workshop"><span class="dropdownItem" >কৰ্মশালা আৰু আলোচনা চক্ৰ</span></b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item href="#"><router-link toggle-class="r-link" to="/AS_Contact">যোগাযোগ কৰক</router-link></b-nav-item>

          <b-nav-item><div id="login"><b-button v-b-modal.modal-header size="sm" variant="outline-danger" style="margin-top: -5px;">
            লগ্‌-ইন </b-button></div>
          </b-nav-item>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
  <span class="support text-orange" id="support">
      ২৪x৭ গ্ৰাহক সেৱা
      <span class="text-danger">  <font-awesome-icon icon="phone"/> ১৯১২</span> বা

      <span class="text-danger"><font-awesome-icon icon="envelope"/> support@apdcl.org</span>
  </span>
  <!-- <span class="language" id="language" >
     <b-input-group  size="sm" class="mb-2" style="width:130px;">
         <b-input-group-prepend  is-text style="background-color:transparent;height:22px ;font-size:15px">
           <b-icon  icon="search" scale="0.75"></b-icon>
         </b-input-group-prepend>
         <b-form-input  style="border: 1px solid #c7c7c7; background-color:transparent;height:22px ;font-size:12px" type="search" placeholder="সন্ধান"></b-form-input>

      </b-input-group>
</span> -->
  <span class="language" id="language" >
      <router-link class="r-link customSpan" to="/">English</router-link>
    </span>


  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg">  </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
  </b-modal>


            <b-modal
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
             class="modal fade"
             id="modal-header"
             title="আপোনাৰ একাউণ্টত লগ্‌-ইন কৰক">
              <div>
                <b-overlay
                  :show="show"
                  spinner-variant="primary"
                  spinner-large
                  rounded="sm"
                  style="z-index:10000;position:absolute"
                  variant="dark"
                  id="loader"
                >

                <b-container>
                  <b-row>
                    <b-col cols=4>
                       <span style="color: #0d47a1;">লগ্‌-ইন কৰক :</span>
                    </b-col>
                      
                    <p id="selectRadio" hidden>Selected: {{ selected }}</p >
                  </b-row>
                </b-container>


              <br>
                <!-- USER LOGIN-->
                  <div id="userDiv" class="showDiv" >
                        <label>ম'বাইল নম্বৰ :  </label>
                      <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
                        <b-input-group-prepend is-text>
                          <b-icon icon="phone"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="number" id="mobileNo" @change="" autocomplete="off" placeholder="ম'বাইল নম্বৰ"></b-form-input>
                      </b-input-group>
                      <span style="display:none;color:red;text-align: center;" id="errorMsg"></span>
                      <div id="sendOtpBtn" class="showDiv">
                        <b-row>
                          <b-col cols="12" offset="">

                              <router-link to="">
                                <b-button block @click="sendOtp()" variant="primary">OTP প্ৰেৰণ কৰক</b-button>
                                </router-link>

                          </b-col>
                        </b-row>
                      </div>

                      <div  id="otpDiv" class="hideDiv">

                        <label>OTP প্ৰবিষ্ট কৰক</label>
                      <b-input-group class="mb-2" style="width:100%;">

                        <b-input-group-prepend is-text>
                          <b-icon icon="check2-circle"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="text" id="otpNo" autocomplete="off" placeholder="OTP প্ৰবিষ্ট কৰক"></b-form-input>
                      </b-input-group>
                      <span style="color:red;padding-left:40%" id="otpInvalid"> </span>
                      <b-row>
                        <b-col cols="12" offset="">
                            <b-button block  @click="loginUser()" variant="primary">লগ্‌-ইন</b-button>
                            <b-button block  @click="resendOtp()" variant="outline-primary">OTP পুনৰ প্ৰেৰণ কৰক</b-button>
                        </b-col>
                      </b-row>
                    </div>

                    </div>

                      <!-- ADMIN LOGIN-->
                      <div id="adminDiv" style="display:none">
                      <b-input-group class="mb-2" style="width:100%;">
                        <b-input-group-prepend is-text>
                          <b-icon icon="person-fill"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="number" :state="userIdState" v-model="user_id" id="user_id" @change="validateConsumer_false('user_id')" autocomplete="off" placeholder="User ID"></b-form-input>
                      </b-input-group>
                      <br><br>
                      <b-input-group class="mb-2" style="width:100%;">
                        <b-input-group-prepend is-text>
                          <b-icon icon="lock-fill"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="password" id="password" autocomplete="off" placeholder="Password"></b-form-input>
                      </b-input-group>
                      <br><br>
                      <b-row>
                        <b-col cols="12" offset="">

                            <router-link to="">
                              <b-button block  id="logInBtn" @click="login()" variant="primary">Log In</b-button>
                              </router-link>

                        </b-col>
                      </b-row>
                    </div>


                      <b-row>
                        <b-col cols="12" style="text-align:center">
                            <span  >আপোনাৰ একাউণ্ট নাই নেকি? <br>
                            <router-link to="/AS_ConsumerRegistration"> পঞ্জীয়ন কৰক</router-link>
                          </span>
                        </b-col>
                      </b-row>
                      <br><br>

                </b-overlay>
              </div>
            </b-modal>

</div>

</template>


<script scoped="true">

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var user = 0;

export default{
  computed:{
   userIdState() {
      return this.user_id.length == 12 ? true : false
      //this.login()
    }
  },
  data() {
      return {
        selected: 'consumer',
        user_id: '',
        show: false,
        mobileNo :''
      }
    },
  created () {
    // When the user scrolls down 50px from the top of the document, resize the header's font size
    window.addEventListener('scroll', this.scrollFunction);
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFunction);
  },
  methods:{
    scrollFunction(event) {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById("header").style.backgroundColor = "#eeeeee";
        document.getElementById("title-a").style.fontSize = "1.3rem";
        document.getElementById("title-e").style.fontSize = "1.3rem";
        document.getElementById("tagline-a").style.fontSize = "0rem";
        document.getElementById("tagline-e").style.fontSize = "0rem";
        document.getElementById("support").style.fontSize = "0rem";
        document.getElementById("language").style.marginTop = "-95px";
      } else {
        document.getElementById("header").style.backgroundColor = "";
        document.getElementById("title-a").style.fontSize = "1.3rem";
        document.getElementById("title-e").style.fontSize = "1.3rem";
        document.getElementById("tagline-a").style.fontSize = "0.9rem";
        document.getElementById("tagline-e").style.fontSize = "0.9rem";
        document.getElementById("support").style.fontSize = "0.8rem";
        document.getElementById("language").style.marginTop = "-115px";
      }
    },


   
   
    sendOtp()
    {
    var mobile = document.getElementById("mobileNo").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent=this;
      this.show=true;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src" : "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };


      axios.request(config)
      .then((response) => {
        console.log(response.data);
        parent.show=false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            document.getElementById("mobileNo").readOnly =true;
            document.getElementById("otpDiv").classList.add("showDiv");
            document.getElementById("sendOtpBtn").classList.remove("showDiv");
            document.getElementById("sendOtpBtn").classList.add("hideDiv");
          }
      })
      .catch((error) => {
        console.log(error);
      });

    },
    loginUser()
    {
 
      var mobile = document.getElementById("mobileNo").value;
      var otpNo = document.getElementById("otpNo").value;

      if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
     

      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
        "src":"portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/otp/verify',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      var parent=this;
      this.show=true;
      axios.request(config)
      .then((response) => {
          if (response.data.status == "success") {
          var accessToken=response.data.accessToken;
          sessionStorage.setItem("accessToken", response.data.accessToken);
          sessionStorage.setItem("consList", JSON.stringify(response.data.consList));
          console.log(response.data.consList[0]);
          var consNo = response.data.consList[0];
          var consType;
         
        let data = JSON.stringify({
            "consNo": consNo,
            "mobileNo":mobile
          });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: parent.$urlCommon+'/api/web/auth/getConsDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
    
      axios.request(config)
      .then((response) => {
        parent.show=false;
        console.log(response.data);
        if(response.data.message=="00")
          {
          sessionStorage.setItem("selectedCons", consNo);
          consType = response.data.connType;
          if(consType == "POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardPostpaid";
                return false;
        
              }
          else if( consType == "SMART POSTPAID")
              {
                  window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                  return false;
             }
          else  if(consType == "PREPAID")
              {
                window.location.href = "/website/ConsumerDashboardPrepaid";
                return false;
               
              }
          else  if(consType == "SMART PREPAID")
              {
                window.location.href="/website/ConsumerDashboardSmartPrepaid";
                return false;
               
              }
          }
        else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }
      })
      .catch((e) => {
        parent.show=false;
        console.log("Caught :::::::::::::::", e.message);
        if(e.message=="Network Error")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }
      });
   
    }
          else
          {
            parent.show=false;
            parent.$bvToast.toast('OTP Invalid !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
          }
      })
      .catch((error) => {
        console.log(error);
        parent.show=false;
            parent.$bvToast.toast('Network Error !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
      });

    },
    resendOtp()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNo").value;
      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "old",
        "src" : "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee+'/auth/login',
        headers: { 
           'Content-Type': 'application/json'
        },
        data : data
      };

      parent.show= true;
      axios.request(config)
      .then((response) => {
      
        parent.show= false;
        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

 
  },
    
  mounted(){
    
  
  }
}

</script>

<style lang="scss" scoped="true" >

.r-link{
  font-size:0.9rem;
}


#header
{
  transition: 0.6s;
}

.title-a
{
  font-size: 1.3rem;
  font-weight: 900;
  margin-top: 0px;
  letter-spacing: 0.5px;


}
.title-e
{
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;

}
.tagline-a
{
    font-size: 0.9rem;
    // font-style: italic;

}
.tagline-e
{
    font-size: 0.9rem;
    // font-style: italic;

}

.responsiveNavbar{

}

table
{
  color:#e4dbdb;
}
td
{
  text-align: left !important;
}
.text-orange
{
  color: #ff5722
}
.text-blue
{
  color: #01579b;
}
.border
{
  border:1px solid;
}
.support
{
  font-size: 0.8rem;
  float: right;
  margin-top: -110px !important;
  margin-right: 170px;
  text-shadow: 0px 0px 1px #0000005c;
}
.language
{
  float: right;
  margin-top: -115px ;
  margin-right: 25px;
  position:relative;
  z-index:1000;
}
.customSpan
{
  background-color: #fff78d;
padding: 4px 10px 4px 10px;
font-weight: 600;
border-radius: 2px;
}

#header,#title-e,#title-a,#tagline-a,#tagline-e,#support,#language
{
  transition: 0.5s;
}

.form-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
}
.logo{
    height:75px;
    width:75px;
    margin-right:20px;
}


.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@media only screen and (max-width: 990px) {
.tagline-a, .tagline-e, .language, .support{
  display:none !important;
}
.title-e, .title-a{
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0px !important;

}
.logo{
  height:35px;
  width:35px;
  margin-right:0px;
}
.nav-bgcolor
{
  background-color:white;
}
.responsiveNavbar{
  padding-left: 20px;
  padding-bottom: 10px;
  background-color: #ffff;
  opacity: 0.95;
}
}

</style>
